module.exports = __webpack_public_path__ + "producr-dried fresh-grass-17.jpg?7764a032f3cbe49c6b611ed542b08668";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-17.jpg
// module id = 75
// module chunks = 0